"use client";

import { useEffect } from "react";
import { RefreshCwIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SpaceError } from "@/components/illustrations/space-error";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <body className="antialiased">
        <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-8 text-center">
          <SpaceError className="w-72 max-w-full" />
          <div className="flex flex-col gap-2">
            <h1 className="text-2xl font-semibold text-foreground">
              Akili is unavailable
            </h1>
            <p className="max-w-sm text-sm text-muted-foreground">
              A critical error occurred. Please refresh the page or try again
              later.
            </p>
            {error.digest && (
              <p className="font-mono text-xs text-muted-foreground/60">
                {error.digest}
              </p>
            )}
          </div>
          <Button variant="outline" onClick={reset} className="gap-2">
            <RefreshCwIcon className="size-4" />
            Reload
          </Button>
        </div>
      </body>
    </html>
  );
}
